import React from 'react';
import ServiceLandingPage, { ServiceConfig } from '../components/ServiceLandingPage';

const config: ServiceConfig = {
  name: 'Battery Replacement',
  icon: '🔋',
  tagline: 'Phone draining fast? Get a genuine battery replaced at your doorstep today.',
  description: 'A degraded battery causes your phone to drain quickly, shut down unexpectedly, or overheat. Minto replaces your battery with a genuine OEM unit at your home or office across Mumbai — no shop visit needed. All battery replacements come with a 180-day warranty, the longest in the industry.',
  price: '699',
  warranty: '180-Day',
  benefits: [
    { icon: '🏠', title: 'Doorstep Service', desc: 'Technician comes to your location — home, office or café.' },
    { icon: '⚡', title: 'Same Day Repair', desc: 'Book before 6 PM and get your battery replaced today.' },
    { icon: '🛡️', title: '180-Day Warranty', desc: 'Longest warranty in the industry — 6 months on battery & labour.' },
    { icon: '🔍', title: 'Genuine OEM Battery', desc: 'We use original OEM batteries — not cheap local cells.' },
    { icon: '🌡️', title: 'Stops Overheating', desc: 'A new battery eliminates overheating caused by swollen old cells.' },
    { icon: '💰', title: 'Transparent Pricing', desc: 'Price shown upfront before booking. No hidden charges.' },
  ],
  brands: ['iPhone', 'Samsung', 'OnePlus', 'Vivo', 'Oppo', 'Realme', 'Motorola', 'Xiaomi', 'Nothing', 'Google Pixel', 'Honor', 'Asus'],
  faqs: [
    { q: 'How long does battery replacement take?', a: 'Battery replacement typically takes 20–40 minutes at your location.' },
    { q: 'What warranty do I get on the battery?', a: 'All battery replacements come with a 180-day (6 months) warranty — the best in Mumbai.' },
    { q: 'Will I lose my data?', a: 'No. Battery replacement does not affect your data at all.' },
    { q: 'How do I know if my battery needs replacement?', a: 'Signs include fast draining, unexpected shutdowns, overheating, or the phone not charging to 100%.' },
    { q: 'Which areas in Mumbai do you cover?', a: 'We cover all major areas including Andheri, Bandra, Dadar, Lower Parel, Borivali, Malad, Goregaon, Vile Parle, Ghatkopar, Kurla, Thane, Chembur and Navi Mumbai.' },
  ],
};

const BatteryReplacementPage: React.FC = () => <ServiceLandingPage config={config} />;
export default BatteryReplacementPage;
